import { useTranslation } from "react-i18next";
import SectionHeading from "../components/SectionHeading";
//import Button from "./ui/Button";
import { HeadingVariant, ButtonVariant } from "../types/constants";
import LeadershipCardsBlock from "../components/LeadershipCardsBlock";
import { useQuery } from "@tanstack/react-query";
import { managementServiceFactory } from "../services/ManagementServiceImpl";
import { ALL_PAGES } from "./../constants";

const managementService = managementServiceFactory();

export default function LeadershipSection() {
    const { t, i18n } = useTranslation();

    const { data: leaders = [] } = useQuery({
        queryKey: ["management", ALL_PAGES, i18n.language],
        queryFn: async () => {
            const { rows } = await managementService.getAll(ALL_PAGES);
            return rows;
        },
    });

    if (!leaders.length) return null;

    return (
        <section className="relative py-20 md:py-24 lg:py-28">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-screen h-full bg-background-400 -z-10" />

            <div className="mx-auto w-[360px] md:w-[688px] lap:max-w-[1440px] lap:w-full flex flex-col">
                <SectionHeading text={t("about.headings.leadership")} variant={HeadingVariant.LIGHT} />
                <p className="font-medium text-xl text-text-400 mt-6">{t("about.paragraphs.leadershipTitle")}</p>
                <p className="font-regular text-base text-text-400 mt-3">{t("about.paragraphs.leadershipText")}</p>
                <LeadershipCardsBlock leaders={leaders} />
                {/* 
                <div className="mt-6 w-full lap:w-auto">
                    <Button text={t("buttons.moreDetails")} variant={ButtonVariant.SECONDARY} />
                </div>
                */}
            </div>
        </section>
    );
}
